
import { BaseVue } from "@newview/base-web";
import searchCom from "./searchCom.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import vxeCell from "./vxeGridCell.vue";
declare let $: any; //declare 只能作用域最外层：
import XEUtils from "xe-utils";
import VXETable from "vxe-table";
import { filter } from "vue/types/umd";
@Component({
  name: "grid",
  components: {
    searchCom,
    vxeCell,
  },
  computed: {},
})
export default class grid extends BaseVue {
  @Prop({ default: "" })
  operates!: any; // 模块按钮权限列表
  gridBoxId = "gridBox_" + this.NewGuid();
  gridEleId = "grid_" + this.NewGuid();
  defaultColWidth = "50px";
  @Prop({ default: "view" })
  gridType!: String; //表格类型('view'只读，'edit'行内编辑)
  @Prop({ default: false })
  notCtrlBtn!: Boolean; //不控制按钮显示(true:不控制，false:控制)
  @Prop({ default: true })
  isToolBar!: Boolean; //是否显示上方工具栏按钮
  @Prop({ default: true })
  isShowAdd!: Boolean; //是否显示添加按钮
  @Prop({ default: true })
  isShowRefresh!: Boolean; //是否显示刷新按钮
  @Prop({ default: true })
  isShowSave!: Boolean; //是否显示保存按钮
  @Prop({ default: false })
  isShowSearch!: Boolean; //是否显示搜索按钮
  @Prop({ default: () => [] })
  toolBarCustom!: Array<Object>; //自定义工具栏按钮列表
  @Prop({ default: "calc(100% - 65px)" })
  gridBoxHeight!: String; //表格高度
  @Prop({ default: null }) gridMaxHeight!: any; //表格最大高度
  @Prop({ default: false })
  loading!: Boolean; //表格是否处于加载中状态
  @Prop({ default: true })
  isPagination!: Boolean; //是否显示分页组件
  @Prop({ default: () => ({ total: 0, pageSize: 25, elevator: true }) })
  paginationSetting: any; //分页参数
  @Prop({
    default: () => ({
      trigger: "click",
      mode: "row",
      showStatus: true,
      autoClear: false, //当点击非编辑列之后，是否自动清除单元格的激活状态（不设置为false的话，行内下拉列表等项将无法进行选择）
    }),
  })
  editconfig: Object | undefined; //表格编辑配置
  @Prop({ default: () => null }) rowConfig: Object | undefined; //表格行配置
  @Prop({ default: () => [] })
  ColConfig!: Array<any>; //列配置参数
  @Prop({ default: true })
  isSelectRow!: Boolean; //是否高亮选中某行
  @Prop({ default: () => [] })
  gridData!: Array<any>; //表格数据
  @Prop({ default: "id" })
  rowKey!: any; //表格数据
  @Prop({ default: () => ({}) })
  searchSetting?: any; //搜索条件配置参数
  @Prop({ default: () => ({}) })
  toolBarClick: any | undefined; //默认工具栏点击事件
  @Prop({ default: () => ({}) })
  rowOperation: any | undefined; //表格行内操作列配置参数
  @Prop({ default: false })
  showSummary!: boolean; // 显示合计
  @Prop({ default: () => ({}) })
  summaryMethod!: Function; // 合计方法
  @Prop({ default: () => 150 })
  handelColWidth!: number;
  @Prop({ default: "" })
  delMsgKey!: any; //删除提示语对应列的key
  @Prop({ default: () => ({}) })
  checkConfig: any | undefined; //复选框配置项
  @Prop({ default: () => [] })
  customRenderer: any | undefined; //自定义列渲染函数
  @Prop({ default: () => ({}) })
  editRules: any | undefined; //编辑校验
  @Prop({ default: () => new Function() })
  spanmethod!: Function; //自定义合并方法    
  @Prop({ default: () => [] })
  mergeSpanCells!: Array<any>; //手动指定合并方法
  @Prop({ default: () => ({}) })
  menuConfig!: any; //右键菜单项
  @Prop({ default: true }) showOverFlow!: Boolean; //	当内容过长时是否显示为省略号，默认是
  @Prop({ default: false }) stripe!: Boolean; //	是否开启隔行换色
  @Prop({ default: null }) actionParams!: any; //调用接口相关参数【可不传】,配置该参数则表格中增删改查全部在组件内部实现
  @Prop({ default: () => ({}) }) cellClassName!: Function; //单元格附加 className
  @Prop({ default: () => ({}) }) rowStyle!: Function; //单元格附加 className
  @Prop({ default: () => ({}) }) headerCellClassName!: Function; //表头附加 className
  @Prop({ default: () => ({ remote: true }) }) filterConfig!: Object; //筛选配置项
  @Prop({ default: false }) showFooter!: Boolean; //是否显示表尾
  @Prop({ default: () => ({}) }) footerMethod!: Function; //表尾数据

  rowOperationNew: any = { isShow: false };
  heightnum: any = 0; //表格具体高度（数字）
  searchBoxIsShow = false; //搜索框默认隐藏
  currentRow: any = {};
  customChangeRows: any = []; //用户程序改过行数据 by msh 20201203
  NewRows: any = []; //记录新增行数据
  CheckedRowArray: any = []; //被勾选的行的数据集合
  defaultRowData = {};
  cellClickEvent(data) {
    //点击行，包括单选框
    this.$emit("cell-Click", data);
  }
  radioChangeEvent(data) {
    //点击单选框
    this.$emit("radio-Change", data);
  }
  selectChangeEvent(data) {
    //复选框点击事件
    // this.$emit("select-Change", data.row, data.records);
    this.$emit("on-check", data.row, data.checked);
  }
  selectAllEvent(data) {
    //复选框全选
    this.$emit("select-All", data.records);
  }

  // 监听customRenderer改变
  @Watch("customRenderer")
  customRendererChange() {
    for (const item of this.customRenderer) {
      (VXETable as any).renderer.add(item.name, item.renderer);
    }
  }
  // 监听gridData改变（勿删，加上可防止报警告）
  @Watch("gridData")
  gridDataChange() {}

  formatDate(value, format) {
    return XEUtils.toDateString(value, format);
  }

  //日期编辑格式化
  DatePickerEdit(row, key, value, format) {
    let valueNew = XEUtils.toDateString(value, format);
    row[key] = valueNew;
  }
  /**
   * @description:  格式化列中下拉列表的文本值
   * @param {*} value
   * @param {*} list
   * @param {*} valueProp
   * @param {*} labelField
   * @return {*}
   */
  getSelectLabel(value, list, valueProp = "value", labelField = "text") {
    const item = XEUtils.find(list, (item) => item[valueProp] === value);
    return item ? item[labelField] : null;
  }

  //监听编辑框，并修改列值（例如，A列编辑值后需要修改B列值）
  inputEdit(scope, item) {
    this.$emit("input-edit", scope.row);
    (this as any).$refs.xTable.updateStatus(scope);
    if (item.input_change) {
      item.input_change(scope.row);
    }
  }

  mounted() {
    // if(this.gridType=="view"){  //此问题与本页157变换解决
    //  // this.editconfig={}
    // }
    if (this.customRenderer) {
      for (const item of this.customRenderer) {
        (VXETable as any).renderer.add(item.name, item.renderer);
      }
    }
    this.autoGenerateRequiredValidRules();

    let $this = this;
    //表格行内操作列配置参数 (合并重新赋值)
    this.rowOperationNew = $.extend(
      {
        title: "操作",
        isShow: true,
        width: 110,
        isEditBtn: true,
        isDelBtn: true,
        otherBtn: [],
      },
      this.rowOperation
    );
    this.$nextTick(() => {

      if (this.gridBoxHeight && this.gridBoxHeight.indexOf("calc") < 0) {
        $("#" + this.gridBoxId).css("height", this.gridBoxHeight);
      }
      setTimeout(() => {
        this.heightnum = $("#" + $this.gridEleId).height();
      }, 50);

      // // 监听表格外部盒子大小发生改变 -- 不生效  暂时先使用下面自定义监听方法
      // let $tar:any = document.getElementById(this.gridBoxId);
      // let mutationObserver = new MutationObserver((mutations)=> {
      //   console.log("xxxxxxxxxxxxxxxx")
      // })
      // mutationObserver.observe($tar)
      this.listenBoxSizeChange()  //监听容器大小改变后重置表格界面
    });
    this.loadDefaultRowData(this.ColConfig);
    this.loadGridDataToApi();
  }
  // 监听容器大小改变后重置表格界面
  listenBoxSizeChange(){
    let prevH = $("#" + this.gridBoxId).height()
    let fun = ()=>{
      if(this.gridIsDestroy){
        return
      }
      setTimeout(() => {
        if($("#" + this.gridBoxId).height()!=prevH){
          this.heightnum = $("#" + this.gridEleId).height();
        }          
        fun()
        prevH = $("#" + this.gridBoxId).height()
      }, 1000);
    }    
    fun()
  }
  gridIsDestroy = false   //表格组件是否要被销毁
  beforeDestroy(){
    this.gridIsDestroy = true
  }

  /**行添加校验规则 */
  validRules: any = {};
  /**
   * 根据ColConfig配置，自动生成必填校验
   */
  autoGenerateRequiredValidRules() {
    const requiredList = this.getRequiredList(this.ColConfig);
    requiredList.forEach((e) => {
      this.validRules[e["key"]] = [
        { required: true, message: `${e["title"]}必须填写` },
      ];
    });
    Object.assign(this.validRules, this.editRules);
  }

  /**获取必填项 */
  getRequiredList(colConfig: any[]) {
    if (!colConfig || colConfig.length === 0) return [];
    let requiredList: any[] = [];
    colConfig.forEach((item) => {
      if (item.required) {
        requiredList.push(item);
      }
      if (item.children) {
        requiredList = requiredList.concat(this.getRequiredList(item.children));
      }
    });

    return requiredList;
  }

  loadDefaultRowData(datas) {
    datas.forEach((item, index) => {
      if (!this.isNull(item.key)) {
        this.defaultRowData[item.key] = "";
        if (item.children && item.children.length > 0) {
          this.loadDefaultRowData(item.children);
        }
      }
    });
  }
  /**
   * @description: 分页控制
   * @param {*} index 当前页数
   * @return {*}
   * @author: pangting
   */
  pageOnChange(index) {
    if (this.paginationSetting.pageChange) {
      this.paginationSetting.pageChange(index);
      return;
    }
    if (this.actionParams) {
      this.loadGridDataToApi(index);
    }
  }
  /**
   * @description: 调接口请求列表数据
   * @param {*}
   * @return {*}
   * @author: pangting
   */
  /**
   * @description: 调接口请求列表数据
   * @param {*} pageIndex
   * @param {*} searchParam
   * @param {*} isRefresh  供外部调用，为true时初始化的默认筛选条件会被searchParam覆盖
   * @return {*}
   * @author: pangting
   */
  async loadGridDataToApi(
    pageIndex = 1,
    searchParam = "1 = 1",
    isRefresh = false
  ) {
    if (this.actionParams) {
      if (this.isNull(this.actionParams.defaultFilter)) {
        this.actionParams.defaultFilter = "1 = 1";
      }
      let grid_filter = this.actionParams.defaultFilter + " And " + searchParam;
      if (isRefresh) {
        grid_filter = searchParam;
      }
      this.gridData.splice(0, this.gridData.length); //清空表格数据
      if (this.isPagination) {
        let pageSize: any = this.paginationSetting
          ? this.paginationSetting.pageSize
          : 30;
        let getMethod = this.actionParams.getMethod
          ? this.actionParams.getMethod
          : "getEntitiesPage";
        let res = this.parseApiResult(
          await this.actionParams.api[getMethod](
            pageIndex,
            pageSize,
            grid_filter,
            this.actionParams.orderBy
          )
        );
        if (res.Datas.length > 0) {
          res.Datas.forEach((element) => {
            this.gridData.push(element);
          });
        }
        this.paginationSetting.total = res.TotalItemCount;
        this.paginationSetting.current = pageIndex;
      } else {
        let getMethod = this.actionParams.getMethod
          ? this.actionParams.getMethod
          : "getEntities";
        let res = this.parseApiResult(
          await this.actionParams.api[getMethod](
            grid_filter,
            this.actionParams.orderBy
          )
        );
        res.forEach((element) => {
          this.gridData.push(element);
        });
      }
    }
  }
  /**
   * @description: 调接口保存数据
   * @param {*} editData 新增、编辑过的数据
   * @return {*}
   * @author: pangting
   */
  async saveGridDataToApi(editData) {
    if (this.actionParams) {
      let saveMethod = this.actionParams.saveMethod
        ? this.actionParams.saveMethod
        : "saves";
      let res = this.parseApiResult(
        await this.actionParams.api[saveMethod](editData)
      );
      if (res > 0) {
        this.success("保存成功");
        this.loadGridDataToApi();
      }
    }
  }
  /**
   * @description: 调接口删除数据
   * @param {*} row 行数据
   * @return {*}
   * @author: pangting
   */
  async delRowToApi(row) {
    if (this.actionParams) {
      let delMethod = this.actionParams.delMethod
        ? this.actionParams.delMethod
        : "delete";
      let res = this.parseApiResult(
        await this.actionParams.api[delMethod](row.id)
      );
      if (res > 0) {
        this.success("删除成功");
        this.loadGridDataToApi();
      }
    }
  }
  //选中某行触发事件
  RowCurrentEvent(row) {
    this.currentRow = row.row;
    this.$emit("row-selected", this.currentRow, row.rowIndex);
  }
  //获取当前选择行数据
  getSelectRow() {
    return this.currentRow;
  }
  RowClickEvent(row, index) {
    // 单击事件
    this.$emit("row-click", row, index);
  }
  RowdbClickEvent(row) {
    this.$emit("row-dbclick", row.row, row.rowIndex);
  }
  //搜索框隐藏/显示
  searchToggle() {
    this.searchBoxIsShow = !this.searchBoxIsShow;
    this.$nextTick(() => {
      this.heightnum = $("#" + this.gridEleId).height();
    });
  }
  initHeight() {
    this.$nextTick(() => {
      this.heightnum = $("#" + this.gridEleId).height();
    });
  }

  searchFun(param) {
    let searchParam = "";
    for (const key in param) {
      if (!this.isNull(param[key])) {
        searchParam += key + " like '%" + param[key] + "%' and ";
      }
    }
    searchParam = searchParam.substring(0, searchParam.length - 5);
    if (searchParam.length == 0) {
      searchParam = "1 = 1";
    }
    this.loadGridDataToApi(1, searchParam);
    this.$emit("on-search", searchParam, param);
  }
  addFun() {
    if (this.toolBarClick.AddFun) {
      //外挂添加
      this.toolBarClick.AddFun();
    } else if (this.toolBarClick.addFun) {
      //外挂添加
      this.toolBarClick.addFun();
    } else {
      this.addRowFun();
    }
  }
  addRowFun(addData: any = {}) {
    let gridObj = (this as any).$refs.xTable;
    let rowId = this.NewGuid();
    let addRow1: any = {
      $IsAdd: true,
    };
    addRow1 = Object.assign(
      JSON.parse(JSON.stringify(this.defaultRowData)),
      addRow1
    );
    let addRow = Object.assign(addRow1, addData);
    addRow[this.rowKey] = rowId;
    addRow.TemId = rowId;
    if (this.gridData == null) this.gridData = [];
    this.gridData.unshift(addRow);
    gridObj.insert(addRow);
    // this.NewRows.push(addRow);
    gridObj.setCurrentRow(addRow); //设置为可编辑状态
    gridObj.setActiveRow(addRow); //设置为可编辑状态
  }
  editRowEvent(row) {
    (this as any).$refs.xTable.setActiveRow(row);
  }
  cancelRowEvent(row) {
    const xTable = (this as any).$refs.xTable;
    xTable.clearActived().then(() => {
      // 还原行数据
      xTable.revertData(row);
    });
  }
  /**
   * 手动设置修改过的行 by msh 2020 12 03
   */
  setCustomChangeRow(row) {
    // console.log(row);
    // let updateRecords = (this as any).$refs.xTable.getUpdateRecords();
    // //Id 判定
    // let finded=false;
    // let adults = updateRecords.filter(u => u[this.rowKey] === row[this.rowKey]);
    // if(adults.length>0) return;
    //    adults = this.NewRows.filter(u => u[this.rowKey] === row[this.rowKey]);
    // if(adults.length>0) return;
    let adults = this.customChangeRows.filter(
      (u) => u[this.rowKey] === row[this.rowKey]
    );
    if (adults.length > 0) return;
    else this.customChangeRows.push(row);
  }
  /**
   * 获取添加/编辑数据
   * @param {*}
   * @return {*}
   */
  getEditDataForGrid() {
    let updateRecords = (this as any).$refs.xTable.getUpdateRecords();
    let insertRecords = (this as any).$refs.xTable.getInsertRecords();
    // console.log("Update"+JSON.stringify(updateRecords));
    // let insertRecords = this.NewRows;
    for (const xobj of updateRecords) {
      let adults = insertRecords.filter(
        (u) => u[this.rowKey] === xobj[this.rowKey]
      );
      if (adults.length == 0) {
        insertRecords.push(xobj);
      }
    }
    // console.log("Insert"+JSON.stringify(insertRecords));
    let editData = insertRecords.concat(this.customChangeRows);
    //在这里实现去重的方法
    let updateAddData: any = [];
    for (const rows of editData) {
      let adults = updateAddData.filter(
        (u) => u[this.rowKey] == rows[this.rowKey]
      );
      if (adults.length <= 0) {
        let pruerow = JSON.parse(JSON.stringify(rows));
        // pruerow.children = [];
        updateAddData.push(pruerow);
      }
    }
    updateAddData.forEach((item, index) => {
      if (item.$IsAdd) {
        item[this.rowKey] = 0;
      }
    });
    // this.NewRows = []; //清空
    this.customChangeRows = []; //清空
    return updateAddData;
  }
  // 表格数据校验
  async validate(successCallBack, errorcallBack) {
    this.NoticeClose();
    const errMap = await this.ref("xTable")
      .fullValidate()
      .catch((errMap) => errMap);
    if (errMap) {
      let msgList = "";
      Object.values(errMap).forEach((errList: any) => {
        errList.forEach((params) => {
          let { rowIndex, column, rules } = params;
          rules.forEach((rule) => {
            msgList += `第 ${rowIndex + 1} 行 ${column.title} 校验错误：${
              rule.message
            }</br>`;
          });
        });
      });
      this.NoticeShow("校验失败", msgList, "warning", 20);
      if (errorcallBack) errorcallBack(msgList);
    } else {
      if (successCallBack) {
        successCallBack();
      }
    }
  }
  //保存方法
  saveFun() {
    let editData = this.getEditDataForGrid();
    if (editData.length == 0) {
      this.warning("您还未添加或修改任何数据！");
      return;
    }
    this.validate(() => {
      if (this.toolBarClick.saveFun) {
        this.toolBarClick.saveFun(editData);
        return;
      }
      this.saveGridDataToApi(editData);
    }, null);
  }
  deleteClickRow(e, row) {
    e.stopPropagation(); //阻止冒泡
    if (row[this.rowKey] && !row.$IsAdd) {
      this.confirm(
        "确定要删除" +
          (row[this.delMsgKey] ? row[this.delMsgKey] : "该条数据") +
          "吗?",
        () => {
          setTimeout(() => {
            if (this.rowOperationNew.delRowEvent) {
              this.rowOperationNew.delRowEvent(row);
              return;
            }
            this.delRowToApi(row);
          }, 50);
        }
      );
    } else {
      let NewRows = (this as any).$refs.xTable.getInsertRecords();
      NewRows.forEach((item, index) => {
        if (item[this.rowKey] == row[this.rowKey]) {
          NewRows.splice(index, 1);
          return;
        }
      });
      this.delListInfoById(row[this.rowKey]);
      if (this.rowOperationNew.delRowEvent) {
        this.rowOperationNew.delRowEvent(row);
        return;
      }
    }
  }
  delListInfoById(Id) {
    var griddata = this.gridData;
    griddata.forEach((item: any, index) => {
      if (item[this.rowKey] == Id) {
        griddata.splice(index, 1);
        return;
      }
    });
  }
  // 刷新按钮
  refreshFun() {
    this.NewRows = [];
    (this as any).$refs.xTable.clearCurrentRow();
    this.currentRow = {};
    if (this.toolBarClick.refreshFun) {
      this.toolBarClick.refreshFun();
      return;
    }
    this.loadGridDataToApi();
  }
  /**
   * @description: 设置行选中状态
   * @param {*} row  行数据
   * @return {*}
   */
  setCurrentRow(row, scrollToRow = false) {
    (this as any).$refs.xTable.setCurrentRow(row);
    this.currentRow = row;
    if (scrollToRow) {
      this.scrollToRow(row);
    }
    this.$emit("row-selected", this.currentRow, row.rowIndex);
  }

  /**
   * @description: 滚动到行
   * @param {*} row  行数据
   * @return {*}
   */
  scrollToRow(row) {
    let rowIndex = (this as any).$refs.xTable.getRowIndex(row);
    let rowHeight = $("#" + this.gridBoxId)
      .find(".vxe-table--body-wrapper")
      .find(".vxe-body--row")
      .eq(0)
      .height();
    setTimeout(() => {
      $("#" + this.gridBoxId)
        .find(".vxe-table--body-wrapper")
        .scrollTop(rowHeight * (rowIndex - 1));
    }, 100);
  }

  scrollToColumn(field) {
    setTimeout(() => {
      (this as any).$refs.xTable.scrollToColumn(field);
    }, 100);
  }
  /**
   * @description: 清空当前高亮的状态
   * @param {*}
   * @return {*}
   * @author: pangting
   */
  clearCurrentRow() {
    this.currentRow = {};
    (this as any).$refs.xTable.clearCurrentRow();
  }
  clearRadioRow() {
    (this as any).$refs.xTable.clearRadioRow();
    (this as any).$refs.xTable.clearCheckboxRow();
  }
  /**
   * @description: 用于 type=checkbox，设置行为选中状态，第二个参数为选中与否
   * @param {*} rows    行数据（数组）
   * @param {*} state   状态 -- 选中与否，不传默认选中
   * @return {*}
   */
  setCheckboxRow(rows, state = true) {
    (this as any).$refs.xTable.setCheckboxRow(rows, state);
  }
  /**
   * @description: 用于 type=checkbox，设置所有行的选中状态
   * @param {*} state  不传默认选中
   * @return {*}
   */
  setAllCheckboxRow(state = true) {
    (this as any).$refs.xTable.setAllCheckboxRow(state);
  }
  /**
   * @description: 用于 type=checkbox，切换某一行的选中状态
   * @param {*} row 行数据
   * @return {*}
   */
  toggleCheckboxRow(row) {
    (this as any).$refs.xTable.toggleCheckboxRow(row);
  }
  /**
   * @description: 用于 type=checkbox，切换所有行的选中状态
   * @param {*}
   * @return {*}
   */
  toggleAllCheckboxRow() {
    (this as any).$refs.xTable.toggleAllCheckboxRow();
  }
  /**
   * @description: 获取grid选中行数据
   * @param {*}
   * @return {*}
   */
  getCheckedRowData() {
    let checkedrow: any = (this as any).$refs.xTable.getRadioRecord();
    let checkedrows: any = (this as any).$refs.xTable.getCheckboxRecords();
    checkedrow != null && checkedrows.push(checkedrow);
    return checkedrows;
  }
  sortChangeEvent({ sortList }) {
    this.$emit("orderselect", sortList[0]);
  }
  roclick(item) {
    this.$emit("roclick", item);
  }
  contextMenuClickEvent({ menu, row, column }) {
    this.$emit("menuClickEvent", menu, row, column);
  }
  /**
   * @description: 刷新表格数据（从第一页开始） 该方法用来供组件外部刷新表格调用
   * @param {*} filter  筛选条件
   * @return {*}
   * @author: pangting
   */
  refreshGridData(filter) {
    this.loadGridDataToApi(1, filter, true);
  }
  setRadioRow(row) {
    (this as any).$refs.xTable.setRadioRow(row);
  }
  setRadioRowById(id) {
    let row: any = {};
    this.gridData.forEach((item, index) => {
      if (id == item["id"]) {
        row = item;
      }
    });
    console.log(row);
    this.setRadioRow(row);
  }
  setCheckRowsByIds(ids, state) {
    let rows: any = [];
    this.gridData.forEach((item, index) => {
      if (ids.indexOf(item[this.rowKey]) >= 0) {
        rows.push(item);
      }
    });
    console.log(rows);
    this.setCheckboxRow(rows, state);
  }
  //java用于反选
  setCheckRowsByIdsJ(ids, state) {
    let rows: any = [];
    this.gridData.forEach((item, index) => {
      if (ids.indexOf(item["id"]) >= 0) {
        rows.push(item);
      }
    });
    this.setCheckboxRow(rows, state);
  }


  getSearchParams(){
    return this.ref("searchComRef")
  }


}
